export const carFiltersMap = {
  BUDGET: 'budget',
  COLORS: 'colors',
  CATEGORIES: 'categories',
  MODELS: 'models',
  BRANDS: 'brands',
  CAR_DESCRIPTION_HIGHLIGHTS: 'carDescriptionHighlights',
  CAR_BODY_TYPE: 'carBodyType',
};

export const usedCarFiltersMap = {
  BUDGET: 'budget',
  COLORS: 'colors',
  CATEGORIES: 'categories',
  MODELS: 'models',
  BRANDS: 'brands',
  CAR_HIGHLIGHTS: 'carHighlights',
  CAR_BODY_TYPE: 'carBodyType',
  CAR_HAND: 'carHand',
  ENGINE_TYPE: 'engineType',
  GEAR_TYPE: 'gearType',
  KM_RANGE: 'kmRange',
  ORIGINAL_OWNERSHIP: 'originOwnership',
  YEARS_RANGE: 'yearsRange',
  WITH_IMAGE: 'imagesLength',
};

export const filterKeyToLabel: { [key: string]: string } = {
  [carFiltersMap.BUDGET]: 'מחיר',
  [carFiltersMap.COLORS]: 'צבע',
  [carFiltersMap.CATEGORIES]: 'קטגוריה',
  [carFiltersMap.MODELS]: 'דגם',
  [carFiltersMap.BRANDS]: 'יצרן',
  [carFiltersMap.CAR_BODY_TYPE]: 'מרכב',
  [carFiltersMap.CAR_DESCRIPTION_HIGHLIGHTS]: 'מאפייני המכונית',
};

export const filterKeyToLabelUsedCar: { [key: string]: string } = {
  [usedCarFiltersMap.BUDGET]: 'מחיר',
  [usedCarFiltersMap.COLORS]: 'צבע',
  [usedCarFiltersMap.CATEGORIES]: 'קטגוריה',
  [usedCarFiltersMap.MODELS]: 'דגם',
  [usedCarFiltersMap.BRANDS]: 'יצרן',
  [usedCarFiltersMap.CAR_BODY_TYPE]: 'מרכב',
  [usedCarFiltersMap.CAR_HIGHLIGHTS]: 'מאפייני המכונית',
  [usedCarFiltersMap.CAR_HAND]: 'יד',
  [usedCarFiltersMap.ENGINE_TYPE]: 'מנוע',
  [usedCarFiltersMap.GEAR_TYPE]: 'תיבת הילוכים',
  [usedCarFiltersMap.KM_RANGE]: 'קילומטראז׳',
  [usedCarFiltersMap.ORIGINAL_OWNERSHIP]: 'בעלות מקורית',
  [usedCarFiltersMap.YEARS_RANGE]: 'שנה',
  [usedCarFiltersMap.WITH_IMAGE]: 'רכבים עם תמונות',
};
